import { mergeClasses } from "../utils/themes.js";
import { useContext, useMemo } from "react";
import { ThemeContext } from "../themes/provider.js";
const useThemePresetClasses = (componentName, customClasses, rootClassName, componentConfig) => {
  const { preset: currentPreset } = useContext(ThemeContext);
  const themeClasses = useMemo(() => {
    var _a;
    return mergeClasses(
      (_a = currentPreset == null ? void 0 : currentPreset[componentName]) == null ? void 0 : _a.classes,
      customClasses,
      rootClassName,
      componentConfig
    );
  }, [componentName, currentPreset, customClasses, rootClassName, componentConfig]);
  return {
    themeClasses
  };
};
export {
  useThemePresetClasses as default
};
